import React, { useState } from 'react';
import Footer from '../navbar/Footer';
import NavigationBar from '../navbar/NavigationBar';
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  TextField,
  List, 
  ListItem, 
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
   ListItemButton,
  Link,
  styled,
  useMediaQuery,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Menu,
  MenuItem,
  Card,
  CardContent,
  Stack,
  LinearProgress
} from '@mui/material';
import {
  Layers,
  InsertDriveFile,
  Description,
  MoreVert,
  Search,
  FileCopy,
  Download,
  Share,
  Home,
  Nature,
  Menu as MenuIcon,
  School,
  Close,
  FamilyRestroom,
  Man,
  TrendingUp,
  Public,
  ExpandMore,
  Email,
  WhatsApp,
  Groups,
  LocalHospital,
  Person,
  Grass,
  Spa,
  BugReport,
  Hive,
  Water as WaterIcon,
  Groups3,
  Handshake,
  Diversity3,
  House,
  Roofing,
  Map,
  Pets as LivestockIcon,
  EggAlt as PoultryIcon,
  Cottage as EmergencyHomeIcon, 
  AccessibilityNew, 
  ChildCare, 
  Terrain, 
  PictureAsPdf,
  Engineering 
} from '@mui/icons-material';


// Constantes de style
const drawerWidth = 240;
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

// Composants stylisés
const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const MobileDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const TotalRow = styled(TableRow)({
  backgroundColor: '#e0e0e0',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#d0d0d0 !important'
  }
});

const AgeGroupRow = styled(TableRow)({
  '&:hover': {
    backgroundColor: '#f5f5f5 !important'
  }
});

const menuItems = [
  { text: 'Ménages par type', icon: <FamilyRestroom color="primary" />, to: '/RGPHAEDataPage' },
  { text: 'Population par localisation', icon: <Public color="primary" />, to: '/PopulationDataPage' },
  { text: 'Ménages collectifs', icon: <Groups color="primary" />, to: '/PopulationCollectiveHouseholdsPage' },
  { text: 'Sans-abris', icon: <EmergencyHomeIcon color="primary" />, to: '/HomelessPopulationPage' },
  { text: 'Ménages ordinaires', icon: <Home color="primary" />, to: '/PopulationResidentPage' },
  { text: 'Sexe et masculinité', icon: <Man color="primary" />, to: '/PopulationDataPageM' },
  { text: 'Rapport de masculinité', icon: <TrendingUp color="primary" />, to: '/MasculinityRatioPage' },
  { text: 'Population par âge', icon: <ChildCare color="primary" />, to: '/PopulationDataPageAge' },
  { text: "Grands groupes d'âge", icon: <AccessibilityNew color="primary" />, to: '/PopulationAgeGroupPageGrand' },
  { text: "Groupes d'âge (éducation)", icon: <School color="primary" />, to: '/PopulationByAgeGroupPage' },
  { text: 'Groupes d\'âge (santé)', icon: <LocalHospital color="primary" />, to: '/AgeGroupPopulationPage' },
  { text: 'Adultes (18+)', icon: <Person color="primary" />, to: '/AdultPopulationPage' },
  
  // Agriculture
  { text: 'Ménages agricoles', icon: <Nature color="primary" />, to: '/AgriculturalHouseholdsPage' },
  { text: 'Pratiques agricoles', icon: <Grass color="primary" />, to: '/AgriculturalHouseholdsPages' },
  { text: 'Types de cultures', icon: <Spa color="primary" />, to: '/AgriculturalHouseholdsPage20' },
  
  // Élevage
  { text: 'Élevage par espèces', icon: <LivestockIcon color="primary" />, to: '/FarmingHouseholdsPage' },
  { text: 'Élevage de volailles', icon: <PoultryIcon color="primary" />, to: '/poultryFarmingPage' },
  { text: 'Élevage spécial', icon: <BugReport color="primary" />, to: '/insectFarmingHouseholdsPage' },
  { text: 'Répartition cheptel', icon: <LivestockIcon color="primary" />, to: '/livestockDistributionPage' },
  { text: 'Répartition volailles', icon: <PoultryIcon color="primary" />, to: '/poultryDistributionPage' },
  
  // Matériel agricole
  { text: 'Équipements agricoles', icon: <Engineering color="primary" />, to: '/agriculturalEquipmentPage' },
  { text: 'Apiculture', icon: <Hive color="primary" />, to: '/beekeepingHouseholdsPage' },
  { text: 'Pêche/aquaculture', icon: <WaterIcon color="primary" />, to: '/fishingHouseholdsPage' },
  
  // Associations
  { text: 'Interventions associations', icon: <Groups3 color="primary" />, to: '/associationInterventionPage' },
  { text: 'Interventions coopératives', icon: <Handshake color="primary" />, to: '/cooperativeInterventionPage' },
  { text: 'Interventions ONG', icon: <Diversity3 color="primary" />, to: '/interventionProjectsPage' },
  
  // Habitat
  { text: "Type d'habitat", icon: <House color="primary" />, to: '/housingDistributionPage' },
  { text: 'Matériau toit', icon: <Roofing color="primary" />, to: '/roofMaterialPage' },
  { text: 'Matériau sol', icon: <Layers color="primary" />, to: '/housingMaterialPage' },
  { text: 'Ménages agricoles', icon: <Terrain color="primary" />, to: '/agriculturalHouseholdsPageProvCom' },
  { text: 'Population par âge/résidence', icon: <Map color="primary" />, to: '/populationAgeResidencePage' },
];

// Données démographiques par groupes d'âges
const ageGroupsData = {
  title: "Répartition de la population des ménages ordinaires par grands groupes d'âges selon le sexe",
  ageGroups: [
    {
      group: "0 - 14 ans",
      total: "5 505 806",
      totalPercentage: "45,1",
      masculin: "2 754 922",
      masculinPercentage: "22,5",
      feminin: "2 750 884",
      femininPercentage: "22,5",
      description: "Enfants et adolescents"
    },
    {
      group: "15 - 49 ans",
      total: "5 448 414",
      totalPercentage: "44,6",
      masculin: "2 486 442",
      masculinPercentage: "20,3",
      feminin: "2 961 972",
      femininPercentage: "24,2",
      description: "Population en âge de procréer"
    },
    {
      group: "15 - 59 ans",
      total: "6 027 615",
      totalPercentage: "49,3",
      masculin: "2 756 203",
      masculinPercentage: "22,5",
      feminin: "3 271 412",
      femininPercentage: "26,8",
      description: "Population active élargie"
    },
    {
      group: "60 ans ou plus",
      total: "687 513",
      totalPercentage: "5,6",
      masculin: "311 950",
      masculinPercentage: "2,6",
      feminin: "375 563",
      femininPercentage: "3,1",
      description: "Population âgée"
    }
  ],
  total: {
    total: "12 220 934",
    totalPercentage: "100,0",
    masculin: "5 823 075",
    masculinPercentage: "47,6",
    feminin: "6 397 859",
    femininPercentage: "52,4"
  }
};

const PopulationAgeGroupPageGrand = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const [openKeyStats, setOpenKeyStats] = useState(true);
  const [openAnalysis, setOpenAnalysis] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleShareMenuOpen = (event) => {
    setShareAnchorEl(event.currentTarget);
  };

  const handleDownloadMenuOpen = (event) => {
    setDownloadAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setShareAnchorEl(null);
    setDownloadAnchorEl(null);
  };

  // Calcul des indicateurs clés
  const keyStats = {
    totalPopulation: ageGroupsData.total.total,
    genderRatio: (
      (parseFloat(ageGroupsData.total.masculin.replace(/\s/g, '')) / 
       parseFloat(ageGroupsData.total.feminin.replace(/\s/g, ''))) * 100
    ).toFixed(1),
    youthPercentage: ageGroupsData.ageGroups.find(g => g.group === "0 - 14 ans").totalPercentage,
    elderlyPercentage: ageGroupsData.ageGroups.find(g => g.group === "60 ans ou plus").totalPercentage,
    workingAgePercentage: ageGroupsData.ageGroups.find(g => g.group === "15 - 59 ans").totalPercentage,
    dependencyRatio: (
      (parseFloat(ageGroupsData.ageGroups.find(g => g.group === "0 - 14 ans").total.replace(/\s/g, '')) + 
       parseFloat(ageGroupsData.ageGroups.find(g => g.group === "60 ans ou plus").total.replace(/\s/g, ''))) /
      parseFloat(ageGroupsData.ageGroups.find(g => g.group === "15 - 59 ans").total.replace(/\s/g, '')) * 100
    ).toFixed(1)
  };

  const filteredAgeGroups = ageGroupsData.ageGroups.filter(group =>
    !searchTerm || group.group.toLowerCase().includes(searchTerm.toLowerCase()) ||
    group.description.toLowerCase().includes(searchTerm.toLowerCase())
  );


  // Composant du menu latéral
  const drawer = (
    <div>
      {isMobile && (
        <MobileDrawerHeader>
          <IconButton onClick={handleDrawerToggle}>
            <Close color="primary" />
          </IconButton>
        </MobileDrawerHeader>
      )}
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={Link}
              to={item.to}
              onClick={isMobile ? handleDrawerToggle : undefined}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );


  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            {drawer}
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
        )}

        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
              </Box>
            )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="h6" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {ageGroupsData.title}
                    </Typography>
                  </Box>
                    <Grid container spacing={1} style={{ marginTop: '5px',marginBottom: '5px' }}>
                          <Grid item xs={12} sm={6} md={6} ></Grid>
                          <Grid item xs={12} sm={6} md={6}>
                                <TextField
                                    size="small"
                                    placeholder="Rechercher groupe d'âge..."
                                    variant="outlined"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    InputProps={{
                                    startAdornment: (
                                   <InputAdornment position="start">
                                       <Search />
                                     </InputAdornment>
                                  ),
                                  }}
                                   sx={{ width: { xs: '100%', sm: '480px' } }}
                              />
                            </Grid>
                            </Grid>
                  {/* Section des indicateurs clés */}
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Indicateurs Démographiques Clés
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Population Totale
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.totalPopulation}
                              </Typography>
                              <Typography variant="caption">
                                Ménages ordinaires
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Ratio de Masculinité
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.genderRatio}
                              </Typography>
                              <Typography variant="caption">
                                Hommes pour 100 femmes
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Population Jeune
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.youthPercentage}%
                              </Typography>
                              <Typography variant="caption">
                                0-14 ans
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Ratio de Dépendance
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.dependencyRatio}
                              </Typography>
                              <Typography variant="caption">
                                Dépendants/Actifs
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des groupes d'âges">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Groupe d'âges</TableCell>
                          <TableCell align="right">Total</TableCell>
                          <TableCell align="right">%</TableCell>
                          <TableCell align="right">Masculin</TableCell>
                          <TableCell align="right">%</TableCell>
                          <TableCell align="right">Féminin</TableCell>
                          <TableCell align="right">%</TableCell>
                          <TableCell align="center">Répartition</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {/* Ligne pour le total Burundi */}
                        <TotalRow hover>
                          <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>
                            BURUNDI
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{ageGroupsData.total.total}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{ageGroupsData.total.totalPercentage}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{ageGroupsData.total.masculin}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{ageGroupsData.total.masculinPercentage}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{ageGroupsData.total.feminin}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{ageGroupsData.total.femininPercentage}</TableCell>
                          <TableCell align="center">
                            <Stack direction="row" spacing={1} alignItems="center">
                              <Box sx={{ width: 60, height: 20, backgroundColor: primaryColor, borderRadius: '10px' }} />
                              <Typography variant="caption">H/F</Typography>
                            </Stack>
                          </TableCell>
                        </TotalRow>

                        {/* Données par groupe d'âge */}
                        {filteredAgeGroups.map((group, index) => (
                          <AgeGroupRow key={index} hover>
                            <TableCell component="th" scope="row">
                              <Box>
                                <Typography variant="body2" fontWeight="medium">
                                  {group.group}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  {group.description}
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell align="right">{group.total}</TableCell>
                            <TableCell align="right">{group.totalPercentage}</TableCell>
                            <TableCell align="right">{group.masculin}</TableCell>
                            <TableCell align="right">{group.masculinPercentage}</TableCell>
                            <TableCell align="right">{group.feminin}</TableCell>
                            <TableCell align="right">{group.femininPercentage}</TableCell>
                            <TableCell align="center">
                              <Box sx={{ width: 80 }}>
                                <LinearProgress 
                                  variant="determinate" 
                                  value={parseFloat(group.masculinPercentage) / parseFloat(group.totalPercentage) * 100} 
                                  sx={{ 
                                    height: 8, 
                                    borderRadius: 4,
                                    backgroundColor: '#ffcccb',
                                    '& .MuiLinearProgress-bar': {
                                      backgroundColor: primaryColor
                                    }
                                  }}
                                />
                                <Typography variant="caption" display="block" textAlign="center" mt={0.5}>
                                  {(parseFloat(group.masculinPercentage) / parseFloat(group.femininPercentage) * 100).toFixed(0)}H/100F
                                </Typography>
                              </Box>
                            </TableCell>
                          </AgeGroupRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                     {/*
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Tooltip title="Copier le tableau">
                      <IconButton onClick={handleCopyTable} sx={{ color: primaryColor }}>
                        <FileCopy />
                      </IconButton>
                    </Tooltip>
                    
                    <Tooltip title="Télécharger les données">
                      <IconButton 
                        onClick={handleDownloadMenuOpen}
                        sx={{ color: secondaryColor }}
                      >
                        <Download />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={downloadAnchorEl}
                      open={Boolean(downloadAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => downloadFile('xlsx')}>
                        <ListItemIcon>
                          <InsertDriveFile fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Excel (.xlsx)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('csv')}>
                        <ListItemIcon>
                          <Description fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>CSV (.csv)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('pdf')}>
                        <ListItemIcon>
                          <PictureAsPdf fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>PDF (.pdf)</ListItemText>
                      </MenuItem>
                    </Menu>
                    
                    <Tooltip title="Partager">
                      <IconButton 
                        onClick={handleShareMenuOpen}
                        sx={{ color: primaryColor }}
                      >
                        <Share />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={shareAnchorEl}
                      open={Boolean(shareAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => shareVia('whatsapp')}>
                        <ListItemIcon>
                          <WhatsApp fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>WhatsApp</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('email')}>
                        <ListItemIcon>
                          <Email fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Email</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('other')}>
                        <ListItemIcon>
                          <MoreVert fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Autre méthode</ListItemText>
                      </MenuItem>
                    </Menu>
                  </Box>
                  */}
                </Paper>
                
                {/* Section d'analyse démographique */}
                <Accordion expanded={openAnalysis} onChange={() => setOpenAnalysis(!openAnalysis)} sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      Analyse démographique
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
                          Structure par âge
                        </Typography>
                        <Typography variant="body2" paragraph>
                          Le Burundi présente une population très jeune avec {keyStats.youthPercentage}% de moins de 15 ans, 
                          caractéristique des pays en développement. La population active (15-59 ans) représente {keyStats.workingAgePercentage}% 
                          de la population totale.
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
                          Répartition par sexe
                        </Typography>
                        <Typography variant="body2" paragraph>
                          La population féminine est légèrement majoritaire (52,4%) avec un ratio de masculinité de {keyStats.genderRatio} 
                          hommes pour 100 femmes. Cette tendance se maintient dans tous les groupes d'âges sauf chez les 0-14 ans 
                          où l'équilibre est parfait.
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
                          Implications socio-économiques
                        </Typography>
                        <Typography variant="body2">
                          Le ratio de dépendance de {keyStats.dependencyRatio} indique qu'il y a environ {keyStats.dependencyRatio} personnes 
                          dépendantes (enfants et personnes âgées) pour 100 personnes en âge de travailler. Cette structure démographique 
                          présente des défis pour l'emploi des jeunes et les systèmes de protection sociale.
                        </Typography>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
                
                {/* Notes méthodologiques */}
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                 <Typography variant="subtitle2" gutterBottom color="primary">
                     Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                       Les données sur la répartition par âge et sexe proviennent du Recensement Général de la Population, 
                       de l'Habitat, de l'Agriculture et de l'Élevage (RGPHAE) 2024. Cette analyse concerne exclusivement 
                       les ménages ordinaires. Les grands groupes d'âges ont été établis selon la classification standard 
                       utilisée lors d'analyse. Les pourcentages sont calculés sur l'effectif 
                       total de chaque sexe. Certaines limitations méthodologiques peuvent affecter la précision des 
                       données, notamment pour les tranches d'âge extrêmes.
                   </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>
      </MainContentWithDrawer>
      
      {/* Pied de page */}
      <Footer />
    </MainContainer>
  );
};

export default PopulationAgeGroupPageGrand;